import {Api, authApi} from "./index";
import jwtDecode from "jwt-decode";


export const registration = async (username, password, name, phoneStudent, linkVk, usernameTg, chatIdTg, city, birthday, isNotifyVk, isNotifyTg) => {
    const {data} = await Api.post(`auth/register`, {
        "username": username.trim(),
        "password": password.trim(),
        "name": name,
        "phoneStudent": phoneStudent,
        "linkVk": linkVk,
        "usernameTg": usernameTg,
        "chatIdTg": chatIdTg,
        "city": city,
        "birthday": birthday,
        "isNotifyVk": isNotifyVk,
        "isNotifyTg": isNotifyTg
    });
    localStorage.setItem('token', data.token);
    return jwtDecode(data.token);
}

export const addTeacher = async (token, username, password, name, phoneTeacher, linkVk, usernameTg) => {
    return await Api.post(`user/add-teacher`, {
        "username": username.trim(),
        "password": password.trim(),
        "name": name,
        "phoneTeacher": phoneTeacher,
        "linkVk": linkVk,
        "usernameTg": usernameTg,
    }, {
        headers: {
            "Authorization": "Bearer " + token
        }
    });
}

export const login = async (username, password) => {
    const {data} = await Api.post(`auth/authenticate`, {"username": username.trim(), "password": password.trim()})
    localStorage.setItem('token', data.token)
    return jwtDecode(data.token)
}

export const checkUsername = async (username) => {
    return await Api.get(`auth/check-username`, {
        params: {
            "username": username.trim()
        }
    })
}

export const check = async () => {
    const {data} = await authApi.get(`http`) //ссылка для проверки пользователя
    localStorage.setItem('token', data.token)
    return jwtDecode(data.token)
}

export const getAllStudentsByGroupId = async (token, groupId, isActive) => {
    return await Api.get(`student-group/by-group`, {
        headers: {
            "Authorization": "Bearer " + token
        },
        params: {
            "group_id": groupId,
            "is_active": isActive
        }
    })
}

export const getAllNewStudentsByGroupId = async (token, groupId) => {
    return await Api.get(`user`, {
        headers: {
            "Authorization": "Bearer " + token
        },
        params: {
            "group_id": groupId,
            "not_in_group": true
        }
    })
}

export const getAllUsersByRole = async (token, role, page, size, sort, searchText) => {
    return await Api.get(`user/by-role`, {
        headers: {
            "Authorization": "Bearer " + token
        },
        params: {
            "role": role,
            "page": page,
            "size": size,
            "sort": sort,
            "search": searchText
        }
    })
}

export const getAllTeachers = async (token) => {
    return await Api.get(`user/teachers`, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}

export const getByCurrent = async (token) => {
    return await Api.get(`user/current`, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}

export const getAllStudentBirthdays = async (token) => {
    return await Api.get(`user/birthdays`, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}

export const getById = async (token, id) => {
    return await Api.get(`user/${id}`, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
}

export const updateAdmin = async (username, password, name, linkVk, usernameTg, chatIdTg, isNotifyVk, isNotifyTg, token) => {
    const {data} = await Api.put(`user/admin`, {
        "username": username.trim(),
        "password": password.trim(),
        "name": name,
        "linkVk": linkVk,
        "usernameTg": usernameTg,
        "chatIdTg": chatIdTg,
        "isNotifyVk": isNotifyVk,
        "isNotifyTg": isNotifyTg
    }, {
        headers: {
            "Authorization": "Bearer " + token
        }
    })
    localStorage.setItem('token', data.token)
    return data
}

export const updateTeacher = async (username, password, name, phoneTeacher, linkVk, usernameTg, isActive, userId, token) => {
    const {data} = await Api.put(`user/teacher`, {
        "username": username.trim(),
        "password": password.trim(),
        "name": name,
        "phoneTeacher": phoneTeacher,
        "linkVk": linkVk,
        "usernameTg": usernameTg,
        "isActive": isActive
    }, {
        headers: {
            "Authorization": "Bearer " + token
        },
        params: {
            "user_id": userId,
        }
    })
    if (userId == null) {
        localStorage.setItem('token', data.token)
    }
    return data
}

export const updateStudent = async (username, password, name, phoneStudent, linkVk, usernameTg, chatIdTg, city, birthday, isNotifyVk, isNotifyTg, userId, token) => {
    const {data} = await Api.put(`user/student`, {
        "username": username.trim(),
        "password": password.trim(),
        "name": name,
        "phoneStudent": phoneStudent,
        "linkVk": linkVk,
        "usernameTg": usernameTg,
        "chatIdTg": chatIdTg,
        "city": city,
        "birthday": birthday,
        "isNotifyVk": isNotifyVk,
        "isNotifyTg": isNotifyTg
    }, {
        headers: {
            "Authorization": "Bearer " + token
        },
        params: {
            "user_id": userId,
        }
    })
    if (userId == null) {
        localStorage.setItem('token', data.token)
    }
    return data
}